import styled from "styled-components";
import { COLORS } from "Styles/Constants";

export const MobileHeaderContainer = styled.div`

    font-family: "Outfit", sans-serif;
 
    .mobile_header_wrapper {
        padding: 15px 0;
        .mygrid-row{
            align-items: center;
        }
    }
    .mobile_menu_nav {
        text-align: right;
        svg{
            font-weight:bold;
            font-size: 36px;
        }
        svg path{
            fill: #EE2D2F;
        }
    }
    .header_mobile_logo img {
        max-width: 130px;
    }
  

}
.MuiButton-label {
    justify-content: flex-end;
}
`;

export const DrawerListContainer = styled.div`


.MuiListItem-gutters {
    padding: 10px 25px;
}
.MuiListItem-button {
    font-family: 'outfit' , sans-serif;
    justify-content:center;
    &:hover{
        color:#EE2D2F;
    }
}.mobile_social_icons a {
    padding: 0 10px;
}
a.portal_login_link {
    color: #000;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    font-family: 'Outfit', sans-serif;
    -webkit-text-decoration: unset;
    text-decoration: unset;
    line-height: 1.1;
}
 .active {
    color: ${COLORS.AccentRed} !important;
  }
`;